import { UIService } from '@1bill-app/services/ui.service';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, HostListener, Input, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { IonSlides, Platform } from '@ionic/angular';
import { NGXLogger } from 'ngx-logger';
import { from, Observable, of } from 'rxjs';
import data from './data';
@Component({
  selector: 'app-comparison-results-cards',
  styleUrls: ['./comparison-results-cards.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
  <div class="swiper" *ngIf="listTemp?.length">
    <div class="nav-wrapper" *ngIf="isSplitPaneVisible$|async">
      <div *ngIf="(isShowNav$|async) && (isBeginning$ | async) === false" class="nav prev" (click)="prevSlide()">
        <ion-icon name="chevron-back"></ion-icon>
      </div>
      <div *ngIf="(isShowNav$|async) && (isEnd$ | async) === false" class="nav next" (click)="nextSlide()">
        <ion-icon name="chevron-forward"></ion-icon>
      </div>
    </div>
    <ion-slides pager="false" [options]="slideOpts" 
      (ionSlideWillChange)="updateSliderIconState()" 
      (ionSlidesDidLoad)="updateSliderIconState()"
      (ionSlideReachEnd)="updateSliderIconState()" 
      (ionSlideReachStart)="updateSliderIconState()" 
    >
      <ion-slide *ngFor="let deal of listTemp; let i = index; trackBy: trackByFn">
        <ion-card class="ion-text-start" color="{{ getCardColor(i) }}" [routerLink]="deal.url">
          <ion-card-content>
            <ion-grid class="ion-no-padding">
              <ion-row>
                <ion-col size="4">
                  <div class="supplier-circle">
                    <ion-img [src]="deal.imgUrl" class="deal-img-url"></ion-img>
                  </div>
                </ion-col>
                <ion-col size="8">
                  <div style="display:block">
                    <strong style="display: inline-block;">{{ deal.title }}</strong>
                    <span class="circle" style="float: right;">
                      <ion-img [src]="deal.productTypeImgUrl" ></ion-img>
                    </span>
                  </div>
                  <div style="font-weight: bold;
                    font-size: 16px;
                    line-height: 120%;
                    letter-spacing: -0.01em;
                    color: #0D2B59;">{{deal.subtitle}}
                  </div>
                  <p>{{ deal.description }}</p>
                </ion-col>
              </ion-row>
            </ion-grid>
          </ion-card-content>
        </ion-card>
      </ion-slide>
    </ion-slides>
  </div>
  `
})
export class ComparisonResultsCardsComponent implements OnInit {
  @ViewChild(IonSlides) slides: IonSlides;
  slideOpts = {
    direction: 'horizontal',
    initialSlide: 0,
    slidesPerView: 'auto',
    spaceBetween: 15,
    slidesOffsetBefore: 15,
    slidesOffsetAfter: 15,

    freeModeSticky: (this.platform.is('android') || this.platform.is('ios')),
    freeModeMomentumBounce: false,
    freeModeMomentumRatio: 0.5,
    freeModeMomentumVelocityRatio: 0.5,
    // grabCursor: true,
  };
  colors = ['card-1', 'card-2'];
  @Input() list: {
    imgUrl: string;
    title: string;
    description: string;
    url: string;
    btnLabel: string;
  }[];

  listTemp: {
    imgUrl: string;
    title: string;
    subtitle: string;
    description: string;
    url: string;
    productTypeImgUrl: string;
    btnLabel: string;
  }[] = data;
  isBeginning$: Observable<boolean>;
  isEnd$: Observable<boolean>;
  isShowNav$: Observable<boolean>;

  isSplitPaneVisible$ = this.uiService.isSplitPaneVisible$;

  constructor(
    private logger: NGXLogger, private router: Router,
    private uiService: UIService, private platform: Platform,
    private cdRef: ChangeDetectorRef,
  ) { }
  async ngOnInit() {
    // this.logger.debug('best deals data: ', this.list);
  }
  ngAfterViewInit() {
  }
  getCardColor(cardIndex: number) {
    const pos = cardIndex + 1;
    const colorIndex = pos % 2 === 0 ? 2 : pos % 2;
    return this.colors[colorIndex - 1];
  }
  getQueryParamMap() {
    const currentUrl = this.router.url;
    return { prev: currentUrl };
  }
  trackByFn(index: number, item: any) {
    return item.title;
  }
  nextSlide() {
    if (this.slides) {
      this.slides.slideNext();
    }
  }
  prevSlide() {
    if (this.slides) {
      this.slides.slidePrev();
    }
  }
  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.updateSliderIconState();
  }
  async updateSliderIconState() {
    const swiper = await this.slides.getSwiper();
    if (!this.slides) return;
    if (swiper) {
      const scrollWidth = swiper.wrapperEl.scrollWidth;
      this.isShowNav$ = of(scrollWidth > swiper.width)
    }
    this.isEnd$ = from(this.slides.isEnd());
    this.isBeginning$ = from(this.slides.isBeginning());
    this.cdRef.detectChanges();
  }
}
